import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import {
  getCategoryChildLinks,
  getCategoryIsEarlyAccess,
  getCategoryDetails,
  getIsEarlyAccessCategoryComingSoon,
  getCategorySiblingLinks,
  getCategoryRelatedLinks
} from "../../state/modules/category";
import { getViewportCategory } from "../../state/modules/layout/selectors";
import {
  getCategoryDetailsFeaturedHeaderData,
  getCategoryDetailsFeaturedHeaderEnabled
} from "../../state/modules/category/selectors";

import CategoryHeader from "./CategoryHeader";
import EarlyAccessCategoryHeader from "../EarlyAccessCategoryHeader";
import FeaturedCategoryHeader from "../FeaturedCategoryHeader";
import {
  getLoyaltyIsEnabled,
  getLoyaltyIsOptedIn
} from "../../state/modules/config/selectors";
import { getCategoryLinks } from "./helpers";

const CategoryHeaderContainer = ({ scrollFunction }) => {
  const hasHeaderLinks = useSelector(getCategoryChildLinks);
  const isEarlyAccess = useSelector(getCategoryIsEarlyAccess);
  const category = useSelector(getCategoryDetails);
  const viewportCategory = useSelector(getViewportCategory);
  const isComingSoon = useSelector(getIsEarlyAccessCategoryComingSoon);
  const isFeaturedHeader = useSelector(getCategoryDetailsFeaturedHeaderEnabled);
  const featuredHeaderData = useSelector(getCategoryDetailsFeaturedHeaderData);
  const mediaType = featuredHeaderData?.web?.videoAssetId ? "video" : "image";
  const loyaltyIsOptedIn = useSelector(getLoyaltyIsOptedIn);
  const loyaltyIsEnabled = useSelector(getLoyaltyIsEnabled);
  const hasSiblingLinks = useSelector(getCategorySiblingLinks);
  const hasRelatedLinks = useSelector(getCategoryRelatedLinks);

  const renderEarlyAccessHeader = () => (
    <EarlyAccessCategoryHeader
      hasHeaderLinks={!!hasHeaderLinks.length}
      category={category}
      viewportCategory={viewportCategory}
      isComingSoon={isComingSoon}
    />
  );

  const renderFeaturedHeader = () => (
    <FeaturedCategoryHeader
      hasHeaderLinks={!!hasHeaderLinks.length}
      category={category}
      mediaType={mediaType}
      viewportCategory={viewportCategory}
      scrollFunction={scrollFunction}
      featuredHeaderData={featuredHeaderData}
    />
  );

  const renderDefaultHeader = () => (
    <CategoryHeader
      hasHeaderLinks={
        !!getCategoryLinks(hasHeaderLinks, hasSiblingLinks, hasRelatedLinks)
          .length
      }
      loyaltyIsOptedIn={loyaltyIsOptedIn}
      category={category}
      loyaltyIsEnabled={loyaltyIsEnabled}
    />
  );

  if (isEarlyAccess) {
    return renderEarlyAccessHeader();
  } else if (isFeaturedHeader) {
    return renderFeaturedHeader();
  } else {
    return renderDefaultHeader();
  }
};

CategoryHeaderContainer.propTypes = {
  scrollFunction: PropTypes.func.isRequired
};

export default CategoryHeaderContainer;
